import { useSelector, useDispatch } from 'react-redux';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import { MAX_GENERATE_NUM } from '../../../config/dataConfig/FJImageToImageData';
import FJGenerateQuantity from './FJGenerateQuantity';
import useLocalStore from '../../../hooks/useLocalStore';

const FJGenerateQuantityContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();

    const generateQuantity = useSelector(state => state.imageToImage.generateQuantity);
    const changeGenerateQuantity = num => {
        dispatch(FJActionImageToImage.updateGenerateQuantityAction(num));
    };
    const onAdd = () => {
        if (generateQuantity < MAX_GENERATE_NUM) {
            changeGenerateQuantity(generateQuantity + 1);
        }
    };
    const onSubtract = () => {
        if (generateQuantity > 1) {
            changeGenerateQuantity(generateQuantity - 1);
        }
    };
    return <FJGenerateQuantity generateQuantity={generateQuantity} onAdd={onAdd} onSubtract={onSubtract} />;
};

export default FJGenerateQuantityContainer;
